module.exports = __webpack_public_path__ + "static/media/attatchment.893587bf.svg";